/* ===========================================================
   THIS NOT THAT — Listicle page interactions
   Guarded so it initialises once even if loaded by multiple
   sections. All queries scoped to .lst so nothing else on the
   page is touched.
   =========================================================== */
(function () {
  'use strict';
  if (window.__listicleInit) return;
  window.__listicleInit = true;

  function init() {
    /* ---------- ingredient list expand ---------- */
    document.querySelectorAll('.lst .ing-toggle').forEach(function (toggle) {
      var list = toggle.parentElement.querySelector('.ingredient-list');
      var label = toggle.querySelector('.ing-toggle-label');
      if (!list) return;
      var more = toggle.getAttribute('data-more') || 'Show more ingredients';
      var fewer = toggle.getAttribute('data-fewer') || 'Show fewer ingredients';
      toggle.addEventListener('click', function () {
        var open = list.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (label) label.textContent = open ? fewer : more;
      });
    });

    /* ---------- reviews carousel(s) ---------- */
    document.querySelectorAll('.lst .carousel-track').forEach(function (track) {
      var scope = track.closest('.lst');
      var cards = track.querySelectorAll('.review-card');
      if (!cards.length) return;
      var index = 0;
      var perView = function () {
        var w = window.innerWidth;
        if (w <= 620) return 1;
        if (w <= 980) return 2;
        return 3;
      };
      var maxIndex = function () { return Math.max(0, cards.length - perView()); };
      var update = function () {
        var card = track.querySelector('.review-card');
        if (!card) return;
        var gap = parseFloat(getComputedStyle(track).gap) || 0;
        var step = card.getBoundingClientRect().width + gap;
        index = Math.min(index, maxIndex());
        track.style.transform = 'translateX(' + (-index * step) + 'px)';
      };
      var prev = scope.querySelector('[data-rev-prev]');
      var next = scope.querySelector('[data-rev-next]');
      if (prev) prev.addEventListener('click', function () { index = index <= 0 ? maxIndex() : index - 1; update(); });
      if (next) next.addEventListener('click', function () { index = index >= maxIndex() ? 0 : index + 1; update(); });
      window.addEventListener('resize', update);
      requestAnimationFrame(update);
    });

    /* ---------- scroll reveal ---------- */
    var reveals = document.querySelectorAll('.lst .reveal');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('in'); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
